import { FilterAudienceForm, Survey } from '@ps/survey-utils';

export function buildFilterAudienceFromSurvey(
  survey: Survey,
): Pick<
  FilterAudienceForm,
  'includeExcludeRespondentsEnabled' | 'permanentExclusionEnabled'
> {
  return {
    includeExcludeRespondentsEnabled: survey.inclExcl === 1,
    permanentExclusionEnabled: !!survey.isPermanentExclusion,
  };
}
